import React from "react";
import styled from "styled-components";
import { device } from "../../device";

import ContentWrapper from "../../components/ContentWrapper";
import AwfireLogoSrc from "../../images/awfire_logo.png";
import phoneIcon from "../../images/telephone.svg";
import emailIcon from "../../images/envelope.svg";

const ContactHeader = styled.h1`
  display: inline-block;
  padding: 0 0 60px 0;
  font-family: "Montserrat", sans-serif;
  font-size: 25px;
  background-color: inherit;
`;

const ContactContentWrapper = styled(ContentWrapper)`
  text-align: center;
  background-color: #f8f8f8;
`;
const ContactContainer = styled.div`
  display: block;

  @media ${device.laptop} {
    padding-bottom: ${(props) => props.paddingBot || "0px"};
    column-gap: 2%;
  }
`;

const Awfire = styled.div`
  text-align: center;
  margin-bottom: 10px;
`;

const AwfireLogo = styled.img`
  width: 100px;
  height: 100px;
  display: inline-block;
`;

const ContactIcon = styled.img`
  width: 40px;
  height: 40px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: bottom;
`;

const ContactInfo = styled.p`
  color: #333;
  font-size: 1.7em;
  display: inline-block;
  padding: 10px;
`;
const PhoneIcon = styled(ContactIcon)``;
const EmailIcon = styled(ContactIcon)``;

const Phone = styled(ContactInfo)``;
const Email = styled(ContactInfo)``;

const Contact = () => (
  <ContactContentWrapper paddingTopBot="50px">
    <ContactHeader>Contact Us</ContactHeader>
    <ContactContainer paddingBot="25px">
      <Awfire>
        <AwfireLogo src={AwfireLogoSrc} />
      </Awfire>
      <Phone>
        <PhoneIcon src={phoneIcon} />
        416-893-6660
      </Phone>
      <Email>
        <EmailIcon src={emailIcon} />
        info@AWFire.ca
      </Email>
    </ContactContainer>
  </ContactContentWrapper>
);

export default Contact;
